import React, { Component } from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell
} from "@mui/material";
import TextField from '@mui/material/TextField';
import Button from "react-bootstrap/Button";
import SystemSettingsActionButton from "../../../components/settings/SystemSettingsActionButton.js";
import Modal from "react-bootstrap/Modal";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import InputAdornment from '@mui/material/InputAdornment';
import SimpleReactValidator from "simple-react-validator";
import { EmailTemplateService } from '../../../service/settings/manage/email.service.js';
import { Spinner } from 'react-bootstrap';
import { sweetConfirmAlert, sweetErrorAlert, sweetStatusAlert, sweetSuccessAlert } from '../../../components/common/SweetAlert';
import ContentWrapper from '../../../components/common/ContentWrapper';
import config from '../../../helper/config';
import {customerConstants} from "../../../helper/constants.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle
const customer = getCustomerFeatureFlag()
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent"
    }
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent"
    }
    break
  default:
    break
}

class ManageEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTableDataLoading: false,
      isLoading: false,
      addEmailModal: false,
      updateEmailModal: false,
      // email: {
      //   template_name: "",
      //   subject: "",
      //   html_content: "",
      // },
      updateEmail: {
        template_name: "",
        subject: "",
        html_content: "",
      },
      selectedEmail: null,
      emails: []
    };
    this.validator = new SimpleReactValidator();
  }

  componentDidMount() {
    this.getAllEmailTemplates();
  }

  getAllEmailTemplates = () => {
    this.setState({ isTableDataLoading: true });
    EmailTemplateService.getAllTemplates()
      .then((response) => {
        if (response.success) {
          this.setState({ emails: response.data, isTableDataLoading: false });
        } else {
          this.setState({ isTableDataLoading: false });
        }
      })
      .catch((error) => {
        console.error("Error while fetching email templates:", error);
        this.setState({ isTableDataLoading: false });
      });
  }

  toggleAddEmailModal = () => {
    const { addEmailModal } = this.state;
    this.validator.purgeFields();
    this.validator.hideMessageFor("template_name");
    this.validator.hideMessageFor("subject");
    this.validator.hideMessageFor("html_content");
  
    if (addEmailModal) {
      this.setState({
        addEmailModal: !addEmailModal,
        updateEmail: {
          template_name: "",
          subject: "",
          html_content: "",
        },
      });
    } else {
      this.setState({
        addEmailModal: !addEmailModal,
      });
    }
  };
  

  toggleUpdateEmailModal = (template) => {
    const { updateEmailModal } = this.state;
    // this.validator.purgeFields();
    // this.validator.hideMessages();
  
    if (!updateEmailModal) {
      this.setState({
        updateEmail: {
          template_name: template.template_name || "",
          subject: template.subject || "",
          html_content: template.html_content || "",
        },
        selectedEmail: template.template_name, // Set the selected email
        updateEmailModal: true,
      });
    } else {
      this.setState({
        updateEmail: {
          template_name: "",
          subject: "",
          html_content: "",
        },
        selectedEmail: null, // Clear the selected email
        updateEmailModal: false,
      });
    }
  };
  



handleSubmit = () => {
  this.setState({ isLoading: true });

  const { updateEmail } = this.state; 

  // if (!this.validator.fieldValid("template_name") || !this.validator.fieldValid("subject") || !this.validator.fieldValid("html_content")) {
  //   this.validator.showMessages();
  //   this.forceUpdate();
  //   this.setState({ isLoading: false }); 
  // } else {
    const newEmail = {
      template_name: updateEmail.template_name,
      subject: updateEmail.subject,
      html_content: updateEmail.html_content,
    };

    EmailTemplateService.addTemplate(newEmail)
      .then((response) => {
        if (response.success) {
          sweetSuccessAlert("Success", "Email template added successfully", "success");
          this.setState({ isLoading: false });
          this.toggleAddEmailModal();
          this.getAllEmailTemplates();
        } else {
          this.setState({ isLoading: false });
          sweetStatusAlert("Info", response.message, "info");
        }
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        sweetErrorAlert("Error", "Error while adding email template", "error");
      });
  // }
};

// Updated handleEditSubmit for email
handleEditSubmit = () => {
  const { updateEmail, selectedEmail } = this.state;

  this.setState({ isLoading: true });

  const editedEmail = {
    template_name: updateEmail.template_name,
    subject: updateEmail.subject,
    html_content: updateEmail.html_content,
  };

  EmailTemplateService.updateTemplate(editedEmail, selectedEmail)
  
    .then((response) => {
      if (response.success) {

        sweetSuccessAlert("Success", "Email template updated successfully", "success");

        // Update the state with the new data
        this.setState((prevState) => ({
          emails: prevState.emails.map((template) =>
          
            template.template_name === selectedEmail ? { ...template, ...editedEmail } : template
            
          ),
        
          isLoading: false,
        }));

        this.toggleUpdateEmailModal();
        this.getAllEmailTemplates();
      } else {
        this.setState({ isLoading: false });
        sweetStatusAlert("Oops", response.message, "info");
      }
    })
    .catch((error) => {
      this.setState({ isLoading: false });
      sweetErrorAlert("Error", "Error while updating email template", "error");
    });
};

  handleDeleteEmail = (templateName) => {
    sweetConfirmAlert()
      .then(() => {
        this.setState({ isTableDataLoading: true });
        EmailTemplateService.deleteTemplate(templateName)
          .then((response) => {
            sweetSuccessAlert("Success", "Email template deleted successfully", "success");
            this.getAllEmailTemplates();
          })
          .catch((error) => {
            sweetStatusAlert("Oops", "Error while deleting email template", "info");
            this.setState({ isTableDataLoading: false });
          });
      });
  }

  handleEmailChange = (event) => {
    const { name, value } = event.target;

    this.setState((prevState) => ({
      updateEmail: {
        ...prevState.updateEmail,
        [name]: value,
      },
      isModified: true,
    }));
  };
  


  render() {
    const {
      addEmailModal,
      updateEmailModal,
      isTableDataLoading,
      isLoading,
      emails,
      updateEmail
    } = this.state;

    return (
      <ContentWrapper>
        <div className="row justify-content-between align-items-center py-5 mb-3">
          <div className="col-md-6 col-6">
            <h3>Manage Email</h3>
          </div>
          <Button
            className="insert-btn"
            variant="primary"
            onClick={this.toggleAddEmailModal}
          >
            Add Email Template
          </Button>
        </div>
        {isTableDataLoading ? (
          <div
            className="loading-container"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "90vh"
            }}
          >
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <div style={{ width: "100%", height: "90vh", overflow: "auto" }}>
            <style dangerouslySetInnerHTML={{__html: `
              @media (max-width: 500px) {
                .html-badge-text-mobile::after {
                  content: "HTML";
                }
                .html-badge {
                  padding: 4px 6px !important;
                  gap: 4px !important;
                }
                .thead {
                  font-size: 0.72rem !important;
                }
              }
              @media (min-width: 501px) {
                .html-badge-text-mobile::after {
                  content: "HTML Included";
                }
              }
            `}} />
            <Table style={{ tableLayout: "fixed", width: "100%" }}>
              <TableHead>
                <TableRow>
                  <TableCell className="thead" sx={{ width: "20%" }}>Template Name</TableCell>
                  <TableCell className="thead" sx={{ width: "30%" }}>Subject</TableCell>
                  <TableCell className="thead" sx={{ width: "30%", whiteSpace: "nowrap" }} align="center">HTML Content</TableCell>
                  <TableCell className="thead" sx={{ width: "20%", minWidth: { xs: "80px", sm: "100px" }, whiteSpace: "nowrap" }} align="right">Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {emails.length > 0 ? (
                  emails.map((template) => (
                    <TableRow key={template.template_name}>
                      <TableCell className="tData" sx={{ width: "20%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {template.template_name}
                      </TableCell>
                      <TableCell className="tData" sx={{ width: "30%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{template.subject}</TableCell>
                      <TableCell className="tData" sx={{ width: "30%" }} align="center">
                        {/* Replaced raw HTML display with badge for better UX */}
                        {/* {template.html_content} */}
                        {template.html_content && (
                          <span className="html-badge" style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "5px 12px",
                            borderRadius: "8px",
                            fontSize: "0.72rem",
                            fontWeight: "700",
                            letterSpacing: "0.5px",
                            color: "#ffffff",
                            background: "linear-gradient(135deg, #ac47ffff 0%, #ab4ff7ff 100%)",
                            boxShadow: "0 2px 8px rgba(194, 71, 255, 0.45), inset 0 1px 0 rgba(255,255,255,0.25)",
                            whiteSpace: "nowrap",
                            textShadow: "0 1px 2px rgba(0,0,0,0.18)",
                          }}>
                            <span style={{
                              display: "inline-block",
                              width: "7px",
                              height: "7px",
                              borderRadius: "50%",
                              backgroundColor: "rgba(255,255,255,0.85)",
                              flexShrink: 0,
                              boxShadow: "0 0 4px rgba(255,255,255,0.7)",
                            }} />
                            <span className="html-badge-text-mobile" />
                          </span>
                        )}
                      </TableCell>
                      <TableCell className="tData" sx={{ width: "20%", minWidth: { xs: "80px", sm: "100px" } }} align="right">
                        <SystemSettingsActionButton type="edit"
                          title="Edit Details"
                          onClick={() => this.toggleUpdateEmailModal(template)}
                         />
                        {/* <IconButton aria-label="delete" color="error" onClick={() => this.handleDeleteEmailTemplate(template.template_name)}>
                            <DeleteIcon />
                        </IconButton> */}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <div style={{ height: "90vh" }}>No emailTemplates available</div>
                )}
              </TableBody>
            </Table>
          </div>
        )}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={addEmailModal}
          onHide={this.toggleAddEmailModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Create New Email</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {isLoading ? (
              <div className="loading-container" style={{ height: "50px" }}>
                <Spinner animation="border" role="status">
                  <span className="sr-only">Please wait...</span>
                </Spinner>
              </div>
            ) : (
              <Form>
                <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="12"
                    controlId="exampleForm.ControlInput1"
                  >
                    <TextField
                      id="outlined-start-adornment"
                      sx={{ width: "100%" }}
                      type="text"
                      name="template_name"
                      defaultValue={updateEmail.template_name}
                      onChange={this.handleEmailChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            Template Name
                          </InputAdornment>
                        ),
                      }}
                    />

                    {this.validator.message(
                      "template_name",
                      updateEmail.template_name,
                      "required",
                      {
                        className: "text-danger",
                      }
                    )}
                  </Form.Group>
                </Row>
                <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="12"
                    controlId="exampleForm.ControlInput1"
                  >
                    <TextField
                      id="outlined-start-adornment"
                      sx={{ width: "100%" }}
                      type="text"
                      name="subject"
                      defaultValue={updateEmail.subject}
                      onChange={this.handleEmailChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            Subject
                          </InputAdornment>
                        ),
                      }}
                    />
                    {this.validator.message(
                      "subject",
                      updateEmail.subject,
                      "required",
                      {
                        className: "text-danger",
                      }
                    )}
                  </Form.Group>
                </Row>
                <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="12"
                    controlId="exampleForm.ControlInput1"
                  >
                    <TextField
                      id="outlined-start-adornment"
                      sx={{ width: "100%" }}
                      type="text"
                      name="html_content"
                      defaultValue={updateEmail.html_content}
                      onChange={this.handleEmailChange}
                      multiline
                      rows={25}
                      // InputProps={{
                      //   startAdornment: (
                      //     <InputAdornment position="start">
                      //       Html Template
                      //     </InputAdornment>
                      //   ),
                      // }}
                    />
                    {this.validator.message(
                      "html_content",
                      updateEmail.html_content,
                      "required",
                      {
                        className: "text-danger",
                      }
                    )}
                  </Form.Group>
                </Row>
              </Form>
            )}

            <Modal.Footer>
              <Button variant="primary" style={ addBtnStyle } onClick={this.handleSubmit}>
                Save
              </Button>
              <Button
                id="modal-close-button"
                style={ closeBtnStyle }
                sx={{ mr: "20px" }}
                onClick={this.toggleAddEmailModal}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={updateEmailModal}
          onHide={this.toggleUpdateEmailModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Email</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {this.state.isLoading ? (
              <div className="loading-container" style={{ height: "50px" }}>
                <Spinner animation="border" role="status">
                  <span className="sr-only">Please wait...</span>
                </Spinner>
              </div>
            ) : (
              <Form>
                <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="12"
                    controlId="exampleForm.ControlInput1"
                  >
                    <TextField
                      id="outlined-start-adornment"
                      sx={{ width: "100%" }}
                      type="text"
                      name="template_name"
                      defaultValue={updateEmail.template_name}
                      onChange={this.handleEmailChange}
                      InputProps={{
                        readOnly: true,
                        startAdornment: (
                          <InputAdornment position="start">
                            Template Name
                          </InputAdornment>
                        ),
                      }}
                    />
                    {/* {this.validator.message(
                      "template_name",
                      updateEmail.template_name,
                      "required",
                      {
                        className: "text-danger",
                      }
                    )} */}
                  </Form.Group>
                </Row>
                <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="12"
                    controlId="exampleForm.ControlInput2"
                  >
                    <TextField
                      id="outlined-start-adornment"
                      sx={{ width: "100%" }}
                      type="text"
                      name="subject"
                      // value={this.state.updateEmail.subject}
                      defaultValue={updateEmail.subject}
                      onChange={this.handleEmailChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            Subject
                          </InputAdornment>
                        ),
                      }}
                    />
                    {/* {this.validator.message(
                      "subject",
                     updateEmail.subject,
                      "required",
                      {
                        className: "text-danger",
                      }
                    )} */}
                  </Form.Group>
                </Row>
                <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="12"
                    controlId="exampleForm.ControlInput3"
                  >
                    <TextField
                      id="outlined-start-adornment"
                      sx={{ width: "100%" }}
                      type="text"
                      name="html_content"
                      // value={this.state.updateEmail.html_content}
                      defaultValue={updateEmail.html_content}
                      onChange={this.handleEmailChange}
                      multiline
                      rows={25}
                      // InputProps={{
                      //   startAdornment: (
                      //     <InputAdornment position="start">
                      //       Html Template
                      //     </InputAdornment>
                      //   ),
                      // }}
                    />
                    {/* {this.validator.message(
                      "html_content",
                      updateEmail.html_content,
                      "required",
                      {
                        className: "text-danger",
                      }
                    )} */}
                  </Form.Group>
                </Row>
              </Form>
            )}

            <Modal.Footer>
              <Button
                className="modal-btn"
                variant="primary"
                style={ addBtnStyle }
                onClick={() => this.handleEditSubmit()}
              >
                Save
              </Button>
              <Button
                className="modal-btn"
                id="modal-close-button"
                style={ closeBtnStyle }
                sx={{ mr: "20px" }}
                onClick={this.toggleUpdateEmailModal}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>
      </ContentWrapper>
    )
  }
}

export default ManageEmail;

